import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13dff892"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bigbox" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("添加商品")
const _hoisted_4 = { class: "tablebox" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pushText" }, "启用推送后，商户端将自动接收该分类数据， 操作不可逆，确认要继续吗？", -1))
const _hoisted_7 = { class: "dialog-footer" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("确认")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pageheader = _resolveComponent("Pageheader")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Publicform = _resolveComponent("Publicform")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_MyTable = _resolveComponent("MyTable")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Pageheader, {
      title: "商品模板库",
      img: _ctx.headerimg,
      text: "商品总库添加的商品将作为模板商品，主动推送给商户，商户可根据实际需要选择是否更新商品库"
    }, null, 8, ["img"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Publicform, {
          formList: _ctx.state.formList,
          formEditObj: _ctx.state.baseformList,
          rules: _ctx.state.rules,
          ref: "addAndEditDom",
          onChangeSelect: _ctx.changeSelect,
          onSubmitForm: _ctx.submitForm
        }, {
          selectThree: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "商品分类" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "select",
                  onChange: _cache[0] || (_cache[0] = (val) => _ctx.changeSelect(val, 1)),
                  clearable: "",
                  modelValue: _ctx.productForm.firstGoodTypeId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.productForm.firstGoodTypeId) = $event)),
                  placeholder: "请选择一级分类"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSimpleArr1, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "select",
                  onChange: _cache[2] || (_cache[2] = (val) => _ctx.changeSelect(val, 2)),
                  clearable: "",
                  modelValue: _ctx.productForm.twoGoodTypeId,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.productForm.twoGoodTypeId) = $event)),
                  placeholder: "请选择二级分类"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSimpleArr2, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "select",
                  onChange: _cache[4] || (_cache[4] = (val) => _ctx.changeSelect(val, 3)),
                  clearable: "",
                  modelValue: _ctx.productForm.threeGoodTypeId,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.productForm.threeGoodTypeId) = $event)),
                  placeholder: "请选择三级分类"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSimpleArr3, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          from: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "warning",
              class: "addbutton",
              style: {"border-radius":"16px"},
              onClick: _ctx.addProduct,
              icon: _ctx.Plus
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["onClick", "icon"])
          ]),
          _: 1
        }, 8, ["formList", "formEditObj", "rules", "onChangeSelect", "onSubmitForm"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_MyTable, {
            tableData: _ctx.tableData?.list,
            isPagination: true,
            isHeight: false,
            total: _ctx.tableData?.total,
            isIndex: true,
            onHandleSizeChange: _ctx.handleSizeChange,
            onHandleCurrentChange: _ctx.handleCurrentChange,
            tableColumn: _ctx.tableColumn,
            currentPage: _ctx.tableData?.pageNum
          }, {
            classImg: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "规格图片",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  (row.productImg)
                    ? (_openBlock(), _createBlock(_component_el_image, {
                        key: 0,
                        zIndex: 8888,
                        class: "classimg",
                        src: row.productImg,
                        onClick: ($event: any) => (_ctx.changeImg(row.productImg))
                      }, null, 8, ["src", "onClick"]))
                    : (_openBlock(), _createBlock(_component_el_image, {
                        key: 1,
                        class: "classimg",
                        src: "/compontsimg/zwtp.png"
                      }))
                ]),
                _: 1
              })
            ]),
            slotName: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "操作",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_button, {
                    color: "#0981FF",
                    onClick: ($event: any) => (_ctx.myclick(row)),
                    round: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["tableData", "total", "onHandleSizeChange", "onHandleCurrentChange", "tableColumn", "currentPage"])
        ]),
        (_ctx.imgViewerVisible)
          ? (_openBlock(), _createBlock(_component_el_image_viewer, {
              key: 0,
              "url-list": [_ctx.imgurl],
              onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.imgViewerVisible = false))
            }, null, 8, ["url-list"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.pushDisplay,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.pushDisplay) = $event)),
          title: "启用推送",
          width: "380px",
          "before-close": _ctx.handleClose
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_el_button, {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.pushDisplay = false)),
                class: "cancelBtn"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.pushDisplay = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["modelValue", "before-close"])
      ])
    ])
  ], 64))
}